module.exports = __webpack_public_path__ + "static/group1_3-895f5ae1dd342a820efd8aa13e33315a.webp";